import { BrowserRouter } from "react-router-dom";

import React, { useEffect, useState } from "react";
import MyRoutes from "../../routes/MyRoutes";

import CssBaseline from "@mui/material/CssBaseline";

import { ThemeProvider } from "@mui/material/styles";
import { useSelector } from "react-redux";

import Login from "../../pages/login/Login";
import ResponsiveDrawer from "../../components/drawer/Drawer";
import { Box, LinearProgress } from "@mui/material";

import rtlPlugin from "stylis-plugin-rtl";

import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";

import { useTranslation } from "react-i18next";

import useStyles from "./appLayoutStyle";
import rtl from "jss-rtl";
import { create } from "jss";
import { StylesProvider, jssPreset } from "@mui/styles";
import {createDarkTheme,createLightTheme} from "../../utils/theme";
// Configure JSS
const jss = create({ plugins: [...jssPreset().plugins, rtl()] });

export default function AppLaout() {
  var [isLogin, setisLogin] = useState("");
  const { i18n } = useTranslation();
  const classes = useStyles();
  useEffect(() => {
    //Get the status of the user if he is logged in or not
    setisLogin(localStorage.getItem("isLogin"));
    //change to  last selected language
    i18n.changeLanguage(localStorage.getItem("lang"));
  }, []);

  // get theme mode dark or light
  const themeMode = useSelector((state) => state.theme.themeMode);
  const Theme = themeMode=="dark"?createDarkTheme(i18n.dir()):createLightTheme(i18n.dir());

  // change body dir
  document.body.dir = i18n.dir();
  const cacheRtl = createCache({
    key: Theme.direction === "rtl" ? "cssrtl" : "cssltr",
    prepend: true,
    stylisPlugins: Theme.direction === "rtl" && [rtlPlugin],
  });
  return (
    <CacheProvider value={cacheRtl}>
      <StylesProvider jss={jss}>
        <ThemeProvider theme={Theme}>
          <div dir={i18n.dir()}>
            <BrowserRouter>
              <CssBaseline />
              {isLogin === "" ? (
                <LinearProgress />
              ) : isLogin == "true" ? (
                <>
                  <ResponsiveDrawer />
                  <Box className={classes.box}>
                    <MyRoutes />
                  </Box>
                </>
              ) : (
                <Login />
              )}
            </BrowserRouter>
          </div>
        </ThemeProvider>
      </StylesProvider>
    </CacheProvider>
  );
}
